import { updateWishlistBtns } from '@components/wishlist';
import { execOnLoad } from '@general/helpers';
import { initPagination } from '@services/pagination';
import './collection-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionPage = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  initPagination({
    callbacks: {
      afterFetch: ({ components: { contentWrapperEl } }) => {
        if (typeof window?.dAgency?.initProductTile === 'function') {
          contentWrapperEl
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => window.dAgency.initProductTile(tile));
        }
        updateWishlistBtns();
      },
    },
  });

  const productsContent = sectionContainer.querySelector('.collection-page__content');
  if (productsContent)
    sectionContainer
      .querySelectorAll('.collection-page__view-switch-value[data-columns][data-device]')
      .forEach((viewChange) =>
        viewChange.addEventListener('click', (e) => {
          e.preventDefault();
          productsContent.setAttribute(`data-columns-${viewChange.dataset.device}`, viewChange.dataset.columns);
          sectionContainer
            .querySelectorAll(
              `.collection-page__view-switch-value[data-columns][data-device="${viewChange.dataset.device}"]`,
            )
            .forEach(
              (selectedView) =>
                (selectedView.dataset.active =
                  selectedView.dataset.columns == viewChange.dataset.columns &&
                  selectedView.dataset.device == viewChange.dataset.device),
            );
        }),
      );

  const desc = sectionContainer.querySelector('.collection-page__description');
  const toggleLink = sectionContainer.querySelector('.read-more-link');

  if (desc && toggleLink) {
    const tempClone = desc.cloneNode(true);
    tempClone.style.maxHeight = 'none';
    tempClone.style.position = 'absolute';
    tempClone.style.visibility = 'hidden';
    tempClone.style.height = 'auto';
    tempClone.style.display = 'block';
    desc.appendChild(tempClone);

    const fullHeight = tempClone.scrollHeight;
    desc.removeChild(tempClone);

    const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
    const twoLineHeight = lineHeight * 2;

    if (fullHeight <= twoLineHeight) {
      toggleLink.style.display = 'none';
    }

    toggleLink.addEventListener('click', function (e) {
      e.preventDefault();
      desc.classList.toggle('expanded');
      toggleLink.classList.toggle('expanded');
    });
  }
};

execOnLoad(window.dAgency.initCollectionPage, '.collection-page__section');
